module.exports = __webpack_public_path__ + "img/Daumen.4660e92c.jpg";